import React from 'react';
import { Text } from "../Text";
import styled from 'styled-components';
import { theme } from "../../theme";
/**
 * MenuNonInteractiveArea
 *
 * A small wrapper for providing consistent typography
 * and spacing when including non interactive elements
 * in a Menu. This should typically be used in its
 * own `MenuGroup`.
 *
 * @example
 *
 * <Menu content={
 *  <>
 *    <MenuGroup>
 *    <MenuNonInteractiveArea>
 *      Hello
 *    </MenuNonInteractiveArea>
 *   </MenuGroup>
 *  }/>
 */

export var MenuNonInteractiveArea = React.forwardRef(function (_ref, forwardedRef) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Container, {
    ref: forwardedRef
  }, typeof children === 'string' ? /*#__PURE__*/React.createElement(Text, {
    variant: "body",
    color: "tertiary"
  }, children) : children);
});
var Container = styled.div.withConfig({
  displayName: "MenuNonInteractiveArea__Container",
  componentId: "vapor__sc-9hnqd4-0"
})(["padding:", " ", ";"], theme.spaces[8], theme.spaces[16]);